export default __webpack_public_path__ + "static/media/help-four.0fd1b14a.png";